/*
interface Navigator {
    // ReSharper disable once IdentifierTypo
    getWebcam: (constraints: MediaStreamConstraints, successCallback: NavigatorUserMediaSuccessCallback, errorCallback: NavigatorUserMediaErrorCallback) => void;
    webKitGetUserMedia: (constraints: MediaStreamConstraints, successCallback: NavigatorUserMediaSuccessCallback, errorCallback: NavigatorUserMediaErrorCallback) => void;
    moxGetUserMedia: (constraints: MediaStreamConstraints, successCallback: NavigatorUserMediaSuccessCallback, errorCallback: NavigatorUserMediaErrorCallback) => void;
    mozGetUserMedia: (constraints: MediaStreamConstraints, successCallback: NavigatorUserMediaSuccessCallback, errorCallback: NavigatorUserMediaErrorCallback) => void;
    msGetUserMedia: (constraints: MediaStreamConstraints, successCallback: NavigatorUserMediaSuccessCallback, errorCallback: NavigatorUserMediaErrorCallback) => void;
    // In reality it has properties and such, but for the sake of this lib:
    userAgentData?: {};
}
*/

namespace SSi.Blazor.Common.Shared.Services.Camera {

    // ReSharper disable once InconsistentNaming
    declare var DotNet: any;

    // streaming indicates if currently streaming video from the camera.
    var streaming: boolean = false;

    var videoElem: HTMLVideoElement;
    var localStream: MediaStream;

    export async function requestCameraPermission(): Promise<boolean> {
        try{
        const constraints = { video: true, audio: false };
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        const tracks = stream.getTracks();
        for (let i = 0; i < tracks.length; i++) {
            const track = tracks[i];
            track.stop();  // stop the opened camera
            return true;
        }
        } catch (ex) {
            console.log(`An exception occurred: ${ex}`);
        }
        return false;
    }


    export async function startPhoto(dotnetHelper, elementId: string): Promise<void> {
        //, widthReq: number
        videoElem = <HTMLVideoElement>(document.querySelector("video#video" + elementId));

        if (videoElem == null) {
            console.log("SetupVideo missing element: video#video" + elementId);
            return;
        }

        // ReSharper disable once StringLiteralTypo
        videoElem.addEventListener("canplay",
            // ReSharper disable once UnusedParameter
            (ev): void => {
                if (!streaming) {
                    /*let height = videoElem.videoHeight / (videoElem.videoWidth / widthReq);

                    // Firefox currently has a bug where the height can't be read from the video, so we will make assumptions if this happens.

                    if (isNaN(height)) {
                        height = widthReq / (4 / 3);
                    }

                    videoElem.setAttribute("width", String(widthReq));
                    videoElem.setAttribute("height", String(height));*/
                    streaming = true;
                }
            },
            false);

        //var widthRegMin = widthReq / 2;
        //var widthRegMax = widthReq * 2;
        try {

            if (navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({
                    audio: false,
                    video: {
                        //facingMode: "environment", width: { min: widthRegMin, ideal: widthReq, max: widthRegMax }
                        facingMode: "environment",
                        //width: { ideal: widthReq }
                    }
                })
                    .then(async function (stream) {
                        localStream = stream;
                        videoElem.srcObject = stream;
                        videoElem.play();
                        console.log("navigator.mediaDevices.getUserMedia started");
                        //dispatchCameraHasRTCResponse(dotnetHelper);
                        await dotnetHelper.invokeMethodAsync("CameraStartResponse");

                    })
                    .catch(async function (err) {
                        var errMsg = err.name + ": " + err.message;
                        console.log(`An error occurred: ${errMsg}`);
                        //dispatchCameraHasRTCErrorResponse(dotnetHelper, errMsg);
                        await dotnetHelper.invokeMethodAsync("CameraErrorResponse", true, true, errMsg);
                    });
            } else {
                var msg = "Web cam is not accessible";
                //dispatchCameraHasRTCErrorResponse(dotnetHelper, msg);
                await dotnetHelper.invokeMethodAsync("CameraErrorResponse", true, false, msg);
            }

        } catch (ex) {
            console.log(`An exception occurred: ${ex}`);
            const exMsg = ex.name + ": " + ex.message;
            //dispatchCameraExceptionResponse(dotnetHelper, exMsg);
            await dotnetHelper.invokeMethodAsync("CameraErrorResponse", false, false, exMsg);
        }
    }

    /*export async function clearCanvas(dotnetHelper): Promise<void> {
        if (canvasElem == null) {
            console.log(`Canvas missing element: ${canvasElem.id}`);
            return;
        }
 
        const context: CanvasRenderingContext2D = canvasElem.getContext("2d");
        context.clearRect(0, 0, canvasElem.width, canvasElem.height);
    }*/


    export async function takePhoto(dotnetHelper): Promise<string> {
        videoElem.pause();
        const width = 800;

        const canvasElem = <HTMLCanvasElement>(document.createElement("canvas"));
        const ctx: CanvasRenderingContext2D = canvasElem.getContext('2d');

        const scaleFactor = width / videoElem.videoWidth;
        var height = scaleFactor * videoElem.videoHeight;
        if (isNaN(height)) {
            height = width / (4 / 3);
        }

        canvasElem.setAttribute("width", String(width));
        canvasElem.setAttribute("height", String(height));

        ctx.drawImage(videoElem, 0, 0, width, height);
        //https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toDataURL
        var photoDataUri = canvasElem.toDataURL('image/jpg', 0.75);
        return photoDataUri;
    }

    function stopVideoImpl(): void {

        videoElem.pause();
        //videoElem.currentTime = 0;

        //videoElem.srcObject.getTracks().forEach(track => {
        //    track.stop();
        //});

        videoElem.srcObject = null;

        localStream.getTracks().forEach((track) => {
            try {
                track.stop();
            } catch (ex) {
                console.log("Track stop ex: " + ex);
            }
        });

        streaming = false;
    }

    export async function stopVideo(dotnetHelper): Promise<void> {
        stopVideoImpl();
        //dispatchCameraOpDoneResponse(dotnetHelper, true);
        await dotnetHelper.invokeMethodAsync("CameraStopResponse");
    }


    async function doSomethingWithFiles(filesInput, dotnetHelper): Promise<void> {
        if (filesInput === null) {
            return;
        }

        // ReSharper disable once QualifiedExpressionMaybeNull
        if (filesInput.files.length <= 0) {
            return;
        }

        var width = 800;

        //const fileName = filesInput.files[0].name;
        const reader = new FileReader();
        reader.onload = event => {
            var img = new Image();
            var target = event.target;
            if (target == null) {
                return;
            }
            img.src = <string>(target.result);
            img.onload = async function () {
                const elem: HTMLCanvasElement = document.createElement("canvas");
                //var elem = document.querySelector("canvas#photoCanvas");

                if (elem == null) {
                    return;
                }

                elem.width = width;
                const scaleFactor = width / img.width;
                elem.height = img.height * scaleFactor;
                var ctx = elem.getContext("2d");
                if (ctx == null) {
                    return;
                }
                // img.width and img.height will contain the original dimensions
                //ctx.drawImage(img, 0, 0, width, height);

                ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
                //var photoDataUri = ctx.canvas.toDataURL(img, mime);
                var photoDataUri = elem.toDataURL('image/jpg', 0.75);
                //await dispatchPhotoStateChange(dotnetHelper, photoDataUri);
                //await dotnetHelper.invokeMethodAsync("PhotoStateChange", photoDataUri, "");
                await dotnetHelper.invokeMethodAsync("CameraPhotoResponse", photoDataUri);
            }
        };
        reader.onerror = async function (error) {
            //readFailure = error;
            console.log(error);
            //await dotnetHelper.invokeMethodAsync("PhotoStateChange", "", error);
            await dotnetHelper.invokeMethodAsync("CameraPhotoErrorResponse", error.toString());
        }

        reader.readAsDataURL(filesInput.files[0]);
    };

    var attached = false;

    export function setupPhotoEventListener(inputElem: HTMLInputElement, dotnetHelper) {
        //const inputElem = <HTMLInputElement>(document.querySelector("input#" + elementId));
        if (inputElem != null) {
            if (attached) {
                console.log("setupPhotoEventListener already attached");
                return;
            }
            inputElem.addEventListener("change", (e) => doSomethingWithFiles(e.target, dotnetHelper));
            attached = true;
            console.log("setupPhotoEventListener attached");
        } else {
            console.log(`setupPhotoEventListener missing element`);
        }
    }

    export function clearPhotoEventListener(inputElem: HTMLInputElement, dotnetHelper): void {
        //const inputElem = <HTMLInputElement>(document.querySelector("input#" + elementId));
        if (inputElem != null) {
            inputElem.removeEventListener("change", (e) => doSomethingWithFiles(e.target, dotnetHelper));
            console.log("clearPhotoEventListener removeEventListener");
            attached = false;
        } else {
            console.log(`clearPhotoEventListener missing element`);
        }
    }

    export function mobileSelectClick(inputElem: HTMLInputElement): void {
        if (inputElem != null) {
            console.log("MobileSelect click");
            inputElem.click();
        } else {
            console.log(`MobileSelect missing element: inputElem`);
        }
    }

    /*export function mobileSelect(dotnetHelper, elementId: string): void {
        var inputElem = <HTMLInputElement>(document.querySelector("input#" + elementId));
        if (inputElem != null) {
            console.log("MobileSelect click");

            var par = inputElem.parentElement;
            if (par != null) {
                par.innerHTML += "";
            }

            inputElem.addEventListener("change", (e) => doSomethingWithFiles(e.target, dotnetHelper));
            inputElem.click();
        } else {
            console.log(`MobileSelect missing element: input#${elementId}`);
            dispatchCameraOpDoneResponse(dotnetHelper, false);
            await dotnetHelper.invokeMethodAsync("CameraOpResponse");
        }
    }*/

    /* WebRTC */

    var videoElement;
    var videoSelect;
    var selectors;
    var videoStream;

    function handleVideoErrorX(error) {
        console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
    }

    function gotVideoDevicesX(deviceInfos) {
        // Handles being called several times to update labels. Preserve values.
        const values = selectors.map(select => select.value);
        selectors.forEach(select => {
            while (select.firstChild) {
                select.removeChild(select.firstChild);
            }
        });
        for (let i = 0; i !== deviceInfos.length; ++i) {
            const deviceInfo = deviceInfos[i];
            const option = document.createElement('option');
            option.value = deviceInfo.deviceId;
            if (deviceInfo.kind === 'videoinput') {
                option.text = deviceInfo.label || `camera ${videoSelect.length + 1}`;
                videoSelect.appendChild(option);
            } else {
                console.log('Some other kind of source/device: ', deviceInfo);
            }
        }
        selectors.forEach((select, selectorIndex) => {
            if (Array.prototype.slice.call(select.childNodes).some(n => n.value === values[selectorIndex])) {
                select.value = values[selectorIndex];
            }
        });
    }


    function gotVideoStreamX(stream) {
        videoStream = stream; // make stream available to console
        videoElement.srcObject = stream;
        // Refresh button list in case labels have become available
        return navigator.mediaDevices.enumerateDevices();
    }


    export function stopVideoX() {
        if (videoStream) {
            videoStream.getTracks().forEach(track => {
                track.stop();
            });
        }
    }

    export function startVideoX() {
        if (videoStream) {
            videoStream.getTracks().forEach(track => {
                track.stop();
            });
        }
        const videoSource = videoSelect.value;
        const constraints = {
            video: { deviceId: videoSource ? { exact: videoSource } : undefined }
        };
        navigator.mediaDevices.getUserMedia(constraints).then(gotVideoStreamX).then(gotVideoDevicesX).catch(handleVideoErrorX);
    }

    export function setupVideoX() {
        navigator.mediaDevices.enumerateDevices().then(gotVideoDevicesX).catch(handleVideoErrorX);
        videoElement = document.querySelector('video');
        videoSelect = document.querySelector('select#videoSource');
        selectors = [videoSelect];
        videoSelect.onchange = startVideoX;
    }



    /* End WebRTC*/
};
